import * as rxjs from 'rxjs'

import type * as me from '../../feature'

import * as gql from './gql'
import type * as models from './models'

/** Provides sibling-user lookups for the currently applied portal context. */
export class Api {
  constructor(private readonly _meFeature: me.Feature) {}

  /** Retrieves users assigned to the most-specific applied portal context. */
  public get(): rxjs.Observable<readonly models.User[]> {
    const scenarioContext =
      this._meFeature.contexts.selectors.scenarioContext.asSignal()
    if (scenarioContext) {
      return gql.queries.inScenario.execute(scenarioContext)
    }

    const appContext = this._meFeature.contexts.selectors.appContext.asSignal()
    if (appContext) {
      return gql.queries.inApp.execute(appContext)
    }

    const zoneContext =
      this._meFeature.contexts.selectors.zoneContext.asSignal()
    return zoneContext ? gql.queries.inZone.execute(zoneContext) : rxjs.of([])
  }
}
